// ***************************************
// Definition of game token WaitingScreen
// ***************************************
import { gameController, flowController } from "../../game_theme/flow_fb/flowController";
import { tbGame } from "../engine/tbGame";
import { ComponentButton } from "../framework/components/ComponentButton";
import { ComponentLabel } from "../framework/components/ComponentLabel";
import { ComponentPicture } from "../framework/components/ComponentPicture";
import { ComponentSpine } from "../framework/components/ComponentSpine";
import { DialogBase } from "../framework/dialogs/DialogBase";
import { tgfHooks } from "../framework/hooks/hooks";
import { tgfDictionary } from "../framework/tgfDictionary";
import { tgfGraphics } from "../framework/tgfGraphics";
import { DialogSettings, MiscSettings } from "../settings/Settings";
import { SoundManager } from "../settings/SoundManager";
import { AngryAnalytics } from "./Analytics/Analytics";
import { angrybirds_regular } from "./AssetDefinitions/FontDefinitions";
import { s_black_square, s_popup_darkblue_rect, s_win_scorebg, s_popup_top, s_popup_bottom, s_ui_pig_green_default_main, s_ui_pig_green_default, s_popup_close, s_icon_close, s_btn_green } from "./AssetDefinitions/ImageDefinitions";
import { waitingturn_animation } from "./AssetDefinitions/SpineDefinitions";
import { CreateShortcutDialog } from "./LobbyCode/CreateShortcutDialog";
import { LoadingOverlay } from "./LobbyCode/LoadingOverlay";
import { WarningDialog } from "./LobbyCode/WarningDialog";
import { playController } from "./gameController";
// The constructor for the WaitingScreen game token.
export var WaitingScreen = function () {
    "use strict";
    // Properties used by the engine
    this.layer = 0;
    this.visible = true;
    this.active = true;
    this.earlySkip = false;
    this.spine = null;
    this.callback = null;
    this._callbackContext = null;
    this.requestNextMatch = false;
    this.closedAsyncCallback = null;
    this.waitingForFB = false;
    this.inputDisabled = false;
    // Add it to the game engine
    tbGame.addToken(this);
};
// ***************************************
// Internal methods
// ***************************************
// Switch Exclamation marks when power up button is pressed
WaitingScreen.prototype._switchExclamationMark = function () {
    "use strict";
    this.exclamationMarkPowerUp.setAlpha(0);
    this.exclamationMark.setAlpha(1);
};
// Add a component to the dialog and returns it
WaitingScreen.prototype._addComponentToDialog = function (Component, properties, moreProperties, extraProperties) {
    "use strict";
    var comp = new Component(properties);
    if (moreProperties !== undefined) {
        comp.setProperties(moreProperties);
    }
    if (extraProperties !== undefined) {
        comp.setProperties(extraProperties);
    }
    this.addComponent(comp);
    return comp;
};
// Add a component to the parent component and returns it
WaitingScreen.prototype._addComponentToComponent = function (parent, Component, properties, moreProperties, extraProperties) {
    "use strict";
    var comp = new Component(properties);
    if (moreProperties !== undefined) {
        comp.setProperties(moreProperties);
    }
    if (extraProperties !== undefined) {
        comp.setProperties(extraProperties);
    }
    parent.components.push(comp);
    return comp;
};
//Iterate over lobbydata and find the first valid match
WaitingScreen.prototype._getNextMatchFromList = function (data) {
    "use strict";
    var pid = tgfHooks.getPlayerID();
    var ctx = tgfHooks.getContextID();
    for (var key in data) {
        if (data.hasOwnProperty(key)) {
            var element = data[key];
            if (element["lobby"]["state"] === 'PLAY' &&
                element["lobby"]["lastTurnID"] !== pid) {
                return data[key];
            }
        }
    }
    return null;
};
WaitingScreen.prototype.closedAsyncPopup = function (comp) {
    comp.activate(); // QBB-1273
    this.waitingForFB = false;
    if (this.closedAsyncCallback) {
        this.closedAsyncCallback();
    }
};
// handleAdd is called when the token is (re-) added to the game. 
WaitingScreen.prototype.handleAdd = function () {
    "use strict";
    playController.sceneControllerActivePopUps = true;
    var self = this;
    this.dialog = new DialogBase({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    this.transparentBlack = new ComponentButton({
        x: -100,
        y: -100,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.dialog.addComponent(this.transparentBlack);
    this.bg = new ComponentPicture({
        image: s_popup_darkblue_rect,
        createFromSlices: true,
        sliceMarginsArray: [55, 55, 55, 55],
        width: 800,
        height: 470,
        x: -800 / 2,
        y: -235
    }, null);
    this.dialog.addComponent(this.bg);
    var backPanel = new ComponentPicture({
        image: s_win_scorebg,
        x: 0,
        y: -170
    }, null);
    this.dialog.addComponent(backPanel);
    this.dialog.addComponent(new ComponentPicture({ image: s_popup_top, x: 0, y: -250 }));
    this.dialog.addComponent(new ComponentPicture({ image: s_popup_bottom, x: 0, y: -250 + 450 }));
    var textHeading = new ComponentLabel({
        x: 0,
        y: DialogSettings.headingHeight,
        text: tgfDictionary.getText("OPPONENTS_TURN_HEADER"),
        font: DialogSettings.headingFont
    });
    this.dialog.addComponent(textHeading);
    var textSubHeading = new ComponentLabel({
        x: 0,
        y: -60,
        text: tgfDictionary.getText("WAITING_FOR_OPPONENT_TEXT"),
        width: this.bg.width * 0.9,
        splitLines: true,
        font: DialogSettings.textFont
    });
    this.dialog.addComponent(textSubHeading);
    var textScore = new ComponentLabel({
        x: -7,
        y: -180,
        text: playController.sceneController.countPigs(playController.isInitiatingPlayer).toString() + " - " + playController.sceneController.countPigs(!playController.isInitiatingPlayer).toString(),
        font: {
            fontFace: angrybirds_regular.fontFace,
            fontSize: 50,
            fontStyle: 'italic',
            fillColor: "#fefefe",
            align: "center",
            padding: 10,
            baseline: "middle"
            //shadow: { active: true, color:'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 4 }
        }
    });
    this.dialog.addComponent(textScore);
    var progressPigLeft = new ComponentPicture({
        image: s_ui_pig_green_default_main,
        width: 60,
        height: 60,
        xScale: -0.5,
        yScale: 0.5,
        x: -125,
        y: -175
    });
    this.dialog.addComponent(progressPigLeft);
    var progressPigRight = new ComponentPicture({
        image: s_ui_pig_green_default,
        width: 60,
        height: 60,
        xScale: 0.5,
        yScale: 0.5,
        x: 118,
        y: -175
    });
    this.dialog.addComponent(progressPigRight);
    this.spine = new ComponentSpine({
        x: 40,
        y: 170,
        scale: 0.85,
        spineAnimation: waitingturn_animation,
        animationClip: "birds_sleeping_intro",
        repeat: false,
        onComplete: function (self) {
            self.repeat = true;
            self.setAnimation("birds_sleeping");
        }
    });
    this.dialog.addComponent(this.spine);
    var closeButton = new ComponentButton({
        image: s_popup_close,
        icon: s_icon_close,
        iconPosition: "center",
        x: 415,
        y: -218,
        touchMargin: MiscSettings.closeButtonTouchMargin,
        onClick: function () {
            if (self.inputDisabled)
                return;
            SoundManager.playEffect(SoundManager.UI_STATE.BACK, SoundManager.UICollection, 0, false);
            playController.sceneControllerActivePopUps = false;
            playController.waitingForPlayerWithoutDialog = true;
            playController.uiController.lobbyButtonContainer.show();
            playController.uiController.lobbyButtonContainer.activate();
            playController.messageHandler.showText(tgfDictionary.getText("WAITING_FOR_OPPONENT_FLOATER_TEXT"), 0, -250, 9999999, 0.5, function callback() { });
            tbGame.removeToken(self);
        }
    });
    this.dialog.addComponent(closeButton);
    var font = {
        fontFace: angrybirds_regular.fontFace,
        fontSize: 32,
        fillColor: "#fefefe",
        align: "center",
        baseline: "middle",
        shadow: { active: true, color: 'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 4 }
    };
    this.backToLobbyButton = new ComponentButton({
        image: s_btn_green,
        y: 300,
        text: tgfDictionary.getText("BTN_RETURN_TO_LOBBY"),
        fontUp: DialogSettings.buttonFont,
        onClick: function () {
            if (self.inputDisabled)
                return;
            AngryAnalytics.reportClickedLobbyDuringMatch();
            SoundManager.playEffect(SoundManager.UI_STATE.BACK, SoundManager.UICollection, 0, false);
            gameController.stopPlay();
            self.callback = null;
            tbGame.removeToken(self);
        }
    });
    this.dialog.addComponent(this.backToLobbyButton);
    this.loader = new LoadingOverlay({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    this.dialog.show();
    if (flowController.shouldShowShortcutRequestNextMatch) {
        tgfHooks.canCreateShortcut().then(function (canCreateShortcut) {
            if (canCreateShortcut) {
                self.shortcutDialog = new CreateShortcutDialog({
                    onClose: function () {
                        self.shortcutDialog = null;
                        if (self.afterShortcutRequest) {
                            self.afterShortcutRequest();
                        }
                    }
                });
                self.shortcutDialog.show();
            }
        });
    }
};
WaitingScreen.prototype.showAdLoader = function () {
    this.waitingForAd = true;
    this.loader.show();
};
WaitingScreen.prototype.hideAdLoader = function () {
    this.waitingForAd = false;
    this.loader.hide();
};
WaitingScreen.prototype.closeNewMatchButtons = function () {
    "use strict";
    this.backToLobbyButton.hide();
};
WaitingScreen.prototype.destroyAndRemove = function () {
    "use strict";
    this.callback = null;
    this.dialog.hide();
    tbGame.removeToken(this);
};
WaitingScreen.prototype.playEndAnimation = function () {
    "use strict";
    if (this.requestNextMatch) {
        return;
    }
    var self = this;
    this.spine.repeat = false;
    this.earlySkip = true;
    this.closeNewMatchButtons();
    //TODO something goes wrong with the animation given!!!!!
    //TODO UPDATE: it is the onComplete bug in spine
    this.spine.setAnimation("birds_sleeping_outro", function () {
        tbGame.removeToken(self);
    });
    this.spine.onEvent = function () {
        if (!playController.isIngame) {
            if (self.callback) {
                self.earlySkip = false;
                self.callback.call(self._callbackContext);
            }
            self.transparentBlack.setAlpha(0);
        }
        else {
            tbGame.removeToken(self);
        }
    };
    this.spine.setEvent("tv");
};
// handleRemove is called when the token is removed from the game.
WaitingScreen.prototype.handleRemove = function () {
    "use strict";
    if (this.gachaScreen) {
        tbGame.removeToken(this.gachaScreen);
    }
    if (playController) {
        playController.waitingScreen = null;
    }
    this.dialog.hide();
    if (this.earlySkip) {
        if (this.callback) {
            this.callback.call(this._callbackContext);
        }
    }
    this.dialog.free();
    gameController.closeNewGameDialogs();
};
WaitingScreen.prototype.setCallback = function (call, context) {
    "use strict";
    if (call && context) {
        this.callback = call;
        this._callbackContext = context;
    }
    else {
        console.log("Something is missing setting this callback");
    }
};
// handleBeginStep is called each step before processing other events.
WaitingScreen.prototype.handleBeginStep = function (timePassed) {
    "use strict";
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
WaitingScreen.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
WaitingScreen.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
};
// handleAlarm is called if a global alarm is reached.
WaitingScreen.prototype.handleAlarm = function (alarm) {
    "use strict";
};
// handleSpecial is called if a special or user-defined event happens.
WaitingScreen.prototype.handleSpecial = function (id, args) {
    "use strict";
};
// handleEndStep is called each step after processing other events (before draw).
WaitingScreen.prototype.handleEndStep = function (timePassed) {
    "use strict";
};
// handleDraw is called at the end of a step to draw the token.
WaitingScreen.prototype.handleDraw = function () {
    "use strict";
};
WaitingScreen.prototype.showNotYourTurn = function () {
    this.notYourTurn = new WarningDialog({
        text: tgfDictionary.getText("GAME_IN_PROGRESS_TEXT")
    });
    this.notYourTurn.show();
    this.notYourTurn.activate();
};
